export const isUpdateAvailableSelector = (state) => state.getIn(['app', 'version', 'updateAvailable']);
export const isCurrentVersionSafeSelector = (state) => state.getIn(['app', 'version', 'isCurrentVersionSafe']);
export const getCurrentAppVersion = (state) => state.getIn(['app', 'version', 'currentVersion']);
